import {
  IncidentProduct,
  IncidentSeverity,
  IncidentStatus,
} from "@redotech/redo-model/incidents/incident";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const updateIncident = {
  name: "updateIncident" as const,
  input: z.object({
    incidentId: zExt.objectId(),
    title: z.string().min(1).nullish(),
    message: z.string().min(1).nullish(),
    severity: createEnum(IncidentSeverity).nullish(),
    status: createEnum(IncidentStatus).nullish(),
    type: createEnum(IncidentProduct).nullish(),
    types: z.array(createEnum(IncidentProduct)).nullish(),
    isGlobal: z.boolean().nullish(),
    isTest: z.boolean().nullish(),
    adminOnly: z.boolean().nullish(),
    routeScoped: z.boolean().nullish(),
    teamIds: z.array(zExt.objectId()).nullish(),
    notes: z.string().nullish(),
    publicUrl: z.string().url().nullish(),
  }),
  output: z.object({ success: z.boolean() }),
};
